// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "dist/css/" + chunkId + "-" + {"405":"b678d468","497":"8b200784","711":"99f71de6","752":"020c5cee","820":"7ee833a4","860":"b626b166","940":"c36fdc93"}[chunkId] + ".css";
};